import commonMapping from "@/mapping/common";

const rip_direction_list = [
  { config: "both", value: "Both", label: "rip_both" },
  { config: "in_only", value: "In only", label: "rip_in" },
  { config: "out_only", value: "Out only", label: "rip_out" },
];

const rip_version_list = [
  { config: "disabled", value: "Disabled", label: "rip_disable" },
  { config: "rip1", value: "RIP_1", label: "rip1" },
  { config: "rip2b", value: "RIP_2B", label: "rip2b" },
  { config: "rip2m", value: "RIP_2M", label: "rip2m" },
];

export const multiLan = {
  dhcp_enable: commonMapping.intToBoolean,
  enable: commonMapping.intToBoolean,
  fixed_dns_enable: commonMapping.intToBoolean,
  rip_direction: rip_direction_list,
  rip_version: rip_version_list,
  default_gateway: commonMapping.intToBoolean,
};

export default multiLan;
